import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-success-password',
    templateUrl: './success-password.component.html',
    styleUrls: ['./success-password.component.scss'],
    standalone: false
})
export class SuccessPasswordComponent implements OnInit {
  loginType: number;

  constructor(private router: Router) { }

  ngOnInit() {
    this.loginType = Number(localStorage.getItem('loginType'));
  }

  navigateLogin() {
    this.router.navigate(['login']);
  }
}
